import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import coachlogo from "../../assets/Images/logonew.png";
import axios from "axios";
import { MenuIcon, Lock, ToggleRight, LogOut } from "lucide-react";
import Menu from "../../base-component/Menu/Menu";
import Dialog from "../../base-component/Dialog/Dialog";
import Loader from "../../base-component/Loader/Loader";
import { X } from "lucide-react";
import toast from "react-hot-toast";
import { adminLogoutApi } from "../../Services/ApiServices";

function TopMenu(props) {
  const navigate = useNavigate();
  const [isLogOut, setIsLogOut] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const Token = localStorage.getItem("token");
  axios.defaults.headers.common["Authorization"] = "Bearer" + Token;
  const userId = localStorage.getItem("admin-user_id");

  const handleLogout = () => {
    setIsLoading(true);
    adminLogoutApi()
      .then((res) => {
        toast.success(res.data.message);
        localStorage.removeItem("coach-admin-token");
        setIsLogOut(false);
        navigate(`/login`);
        setIsLoading(false);
      }).catch((err) => {
        toast.error(err.response.data.message);
        setIsLogOut(false);
        setIsLoading(false);
      });
  };

  return (
    <>
      <header className="sticky top-0 z-9 flex w-full bg-white drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
        <div className="flex flex-grow items-center justify-between lg:justify-between py-3 px-4 shadow-2 md:px-8">
          <div className="flex items-center justify-between gap-2 sm:gap-4">
            <button
              aria-controls="sidebar"
              onClick={(e) => {
                e.stopPropagation();
                props.setSidebarOpen(!props.sidebarOpen);
              }}
              className="z-99 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark 2xl:hidden xl:hidden lg:hidden"
            >
              <MenuIcon className="w-5 h-5" />
            </button>
          </div>

          <div className="flex items-center">
            <Menu>
              <Menu.Button className="flex items-center mt-1">
                <div className="w-12 h-13 flex p-1 items-center justify-center">
                  <img
                    src={coachlogo}
                    crossOrigin="anonymous"
                    className="w-full object-cover"
                    alt=""
                  />
                </div>
              </Menu.Button>

              <Menu.Items className="w-56 mt-1 text-white bg-[#2C5BA7]">
                <Menu.Header className="font-normal">
                  <div className="font-medium text-center text-lg">Coach It Right Admin</div>
                </Menu.Header>
                <Menu.Divider className="bg-white/[0.08]" />
                <Menu.Item
                  onClick={() => navigate(`/changepassword`)}
                  className="group bg-[#ffffff2c]/5 hover:bg-[#EAEFF6] hover:text-gray-900 transition duration-200 mb-2"
                >
                  <Lock className="w-4 h-4 mr-2 group-hover:text-gray-900" /> Change Password
                </Menu.Item>

                <Menu.Item 
                  onClick={() => setIsLogOut(true)} 
                  className="group bg-[#ffffff2c]/5 hover:bg-[#EAEFF6] hover:text-gray-900 transition duration-200"
                >
                  <ToggleRight className="w-4 h-4 mr-2 group-hover:text-gray-900" /> Logout
                </Menu.Item>
              </Menu.Items>
            </Menu>
          </div>
        </div>
      </header >

      <Dialog
        open={isLogOut}
        onClose={() => setIsLogOut(false)}
        className="relative z-50"
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="h-auto overflow-auto rounded-2xl p-0">
            <div className="px-4 py-4 text-center relative" style={{ backgroundColor: '#E8F2FC' }}>
              <button
                onClick={() => setIsLogOut(false)}
                className="absolute cursor-pointer top-4 right-4 w-6 h-6 bg-[#475467] rounded-full flex items-center justify-center text-white transition-colors"
              >
                <X size={18} />
              </button>

              <div className="flex justify-center">
                <div className="w-24 h-24 rounded-full flex items-center justify-center">
                  <LogOut size={56} className="text-[#2C5BA7]" />
                </div>
              </div>
            </div>

            <div className="bg-white px-6 py-8 text-center w-full ">
              <div className="md:text-2xl text-base w-full m-auto text-center font-semibold text-gray-800 mb-4">
                Log Out?
              </div>

              <Dialog.Description className="md:text-base text-sm text-gray-600 mb-8 leading-relaxed">
                Are you sure you want to log out? You'll need to sign in again
                to access your account.
              </Dialog.Description>

              <button
                onClick={handleLogout}
                disabled={isLoading}
                className="flex-1 px-6 h-12 shadow cursor-pointer bg-[#4373c1] w-full text-white font-medium rounded-xl hover:bg-[#2C5BA7] transition-colors"
              >

                {isLoading ? <Loader /> : "Yes, Log out"}
              </button>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </>
  );
}

export default TopMenu;
